import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LetDirective, PushPipe } from '@ngrx/component';
import { FlexModule } from 'ng-flex-layout/flex';
import { MomentModule } from 'ngx-moment';
import { FromNowPipe } from './pipes/from-now.pipe';
import { InArrayPipe } from './pipes/in-array.pipe';
import { MapPipe } from './pipes/map.pipe';
import { MomentPipe } from './pipes/moment.pipe';
import { PairMapAsyncPipe } from './pipes/pair-map-async.pipe';
import { PairMapPipe } from './pipes/pair-map.pipe';
import { ProfileImagePipe } from './pipes/profile-image.pipe';
import { RemoveStorageUidPipe } from './pipes/remove-storage-uid.pipe';
import { SplitCamelPipe } from './pipes/split-camel.pipe';
import { SplitKebabPipe } from './pipes/split-kebab.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { TypeGuardPipe } from './pipes/type-guard.pipe';

@NgModule({
  imports: [
    CommonModule,
    LetDirective,
    PushPipe,
    SplitCamelPipe,
    SplitKebabPipe,
    MomentPipe,
    MomentModule,
    MapPipe,
    TimeFormatPipe,
    ProfileImagePipe,
    InArrayPipe,
    PairMapPipe,
    PairMapAsyncPipe,
    FromNowPipe,
    FormsModule,
    ReactiveFormsModule,
    TypeGuardPipe,
    FlexModule,
    RemoveStorageUidPipe,
  ],
  exports: [
    CommonModule,
    LetDirective,
    PushPipe,
    SplitCamelPipe,
    SplitKebabPipe,
    MomentPipe,
    MomentModule,
    MapPipe,
    TimeFormatPipe,
    ProfileImagePipe,
    InArrayPipe,
    PairMapPipe,
    PairMapAsyncPipe,
    FromNowPipe,
    FormsModule,
    ReactiveFormsModule,
    TypeGuardPipe,
    FlexModule,
    RemoveStorageUidPipe,
  ],
})
export class NgCommonModule {}
